import { Nav, NavItem } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import * as Features from '../../../shared/Features';
import * as OrderTypes from './OrderTypes';
import * as ProductProperty from '../../../shared/ProductProperties';
import * as React from 'react';
import { UserRole } from '../../../shared/types';

type ViewOrderPageNavigationBarLabels = {
    editOrder: string;
    basicOrderinfo: string;
    video: string;
    imageProcessing: string;
    showcase: string;
    text: string;
    plan: string;
    matterport: string;
    sePlay: string;
    logs: string;
    digitalStyling: string;
};

type ViewOrderPageNavigationBarProps = {
    activeTab: string;
    onSelect: (key) => void;
    user: any;
    order: any;
    photoIsArchived: boolean;
    planIsArchived: boolean;
    userRole: string;
    labels: ViewOrderPageNavigationBarLabels;
};

export const ViewOrderPageNavigationBar = (props: ViewOrderPageNavigationBarProps) => {
    let { activeTab, onSelect, user, order, photoIsArchived, planIsArchived, userRole, labels } =
        props;
    const handleSelect = (key) => {
        onSelect(key);
    };

    // TODO: WE GET THE INCORRECT photoIsArchived and planIsArchived values here!!

    return (
        <Nav
            aria-label="view-order-page-nav-bar"
            bsStyle="tabs"
            activeKey={activeTab}
            onSelect={(key) => handleSelect(key)}
        >
            {userRole === UserRole.Photographer &&
                order &&
                order._photoOrderStatus &&
                (order._photoOrderStatus.value === 1 || order._photoOrderStatus.value === 3) && (
                    <NavItem eventKey={'edit'}>{labels.editOrder}</NavItem>
                )}

            {Features.hasFeature(Features.ViewBasicOrderInfo, user) ||
            Features.hasFeature(Features.ViewStylingOrder, user) ? (
                <NavItem eventKey={'basic'}>{labels.basicOrderinfo}</NavItem>
            ) : null}

            {!photoIsArchived &&
                Features.hasFeature(Features.ListFilmOrders, user) &&
                (order.orderType & OrderTypes.photo) !== 0 &&
                order.productProperties &&
                order.productProperties.some(
                    (property) => property.value === ProductProperty.Film
                ) && <NavItem eventKey={'video'}>{labels.video}</NavItem>}

            {!photoIsArchived &&
                Features.hasAnyFeature(
                    [Features.ViewEditedImages, Features.ViewDeliveredEditedImages],
                    user
                ) &&
                (order.orderType & OrderTypes.photo) !== 0 &&
                !order.isStylingOrder && (
                    <NavItem eventKey={'image'}>{labels.imageProcessing}</NavItem>
                )}

            {!photoIsArchived &&
                Features.hasFeature(Features.ViewCopyOrder, user) &&
                (order.orderType & OrderTypes.photo) !== 0 &&
                order.productProperties &&
                order.productProperties.some(
                    (property) => property.value === ProductProperty.Text
                ) && <NavItem eventKey={'text'}>{labels.text}</NavItem>}

            {!planIsArchived &&
                (Features.hasAnyFeature(
                    [Features.ViewAdminPlanOrder, Features.ViewPlanOrder],
                    user
                ) ||
                    (order.isMeasured &&
                        Features.hasFeature(Features.ViewPlanOrderWhenMeasured, user))) &&
                (order.orderType & OrderTypes.plan) !== 0 && (
                    <NavItem eventKey={'plan'}>{labels.plan}</NavItem>
                )}

            {props.order.productProperties &&
            props.order.productProperties.some(
                (property) => property.value === ProductProperty.DigitalStyling
            ) ? (
                <NavItem eventKey={'digital-styling'}>{labels.digitalStyling}</NavItem>
            ) : null}

            {(user.details.role === UserRole.Admin ||
                user.details.role === UserRole.Support ||
                user.details.role === UserRole.BrokerAgent ||
                user.details.role === UserRole.BrokerAgentAssistant ||
                user.details.role === UserRole.BrokerAgentAdmin) &&
                (order.orderType & OrderTypes.photo) !== 0 &&
                order.productProperties &&
                order.productProperties.some(
                    (property) => property.value === ProductProperty.Matterport
                ) && <NavItem eventKey={'matterport'}>{labels.matterport}</NavItem>}

            {(user.details.role === UserRole.Admin ||
                user.details.role === UserRole.Support ||
                user.details.role === UserRole.BrokerAgent ||
                user.details.role === UserRole.BrokerAgentAssistant ||
                user.details.role === UserRole.BrokerAgentAdmin) &&
                (order.orderType & OrderTypes.photo) !== 0 &&
                order.productProperties &&
                order.productProperties.some(
                    (property) => property.value === ProductProperty.SEPlay
                ) && (
                    <NavItem aria-label="seplay-nav-item" eventKey={'seplay'}>
                        {labels.sePlay}
                    </NavItem>
                )}

            {Features.hasFeature(Features.ViewLogs, user) && (
                <NavItem eventKey={'logs'}>{labels.logs}</NavItem>
            )}
            {props.order.productProperties &&
            props.order.productProperties.some(
                (property) => property.value === ProductProperty.Showcase
            ) ? (
                <NavItem eventKey={'showcase'}>{labels.showcase}</NavItem>
            ) : null}
        </Nav>
    );
};

const TranslatedViewOrderPageNavigationBar = (props) => {
    let labels: ViewOrderPageNavigationBarLabels = {
        editOrder: Translate('view-order/tab-titles/edit-order'),
        basicOrderinfo: Translate('view-order/tab-titles/basic-info'),
        video: Translate('view-order/tab-titles/video-handling'),
        imageProcessing: Translate('view-order/tab/image-processing'),
        text: Translate('view-order/tab-titles/text-handling'),
        showcase: Translate('view-order/tab/showcase/legend/showcase'),
        plan: Translate('view-order/tab/plan-order'),
        matterport: Translate('view-order/tab/matterport'),
        sePlay: Translate('view-order/tab/se-play'),
        logs: Translate('view-order/tab/logs'),
        digitalStyling: Translate('view-order/tab/digital-styling')
    };
    return <ViewOrderPageNavigationBar {...props} labels={labels} />;
};

export default TranslatedViewOrderPageNavigationBar;
